import React from 'react';
import styles from './PreviouslyConnectedAccounts.module.scss';

interface PreviouslyConnectedAccountsProps {
  accounts: Array<{ companyName: string }>;
}

const PreviouslyConnectedAccounts: React.FC<
  PreviouslyConnectedAccountsProps
> = ({ accounts }) => {
  if (!accounts || accounts.length === 0) {
    return null;
  }

  return (
    <div className={styles.scrollableAccountsList}>
      {accounts.map((account, index) => (
        <div key={index} className={styles.accountItem}>
          <div className={styles.checkboxContainer}>
            <input
              type="checkbox"
              checked={true}
              disabled={true}
              className={styles.disabledCheckbox}
            />
          </div>
          <span className={styles.companyName}>{account.companyName}</span>
        </div>
      ))}
    </div>
  );
};

export default PreviouslyConnectedAccounts;
